import { LoginApiRequest, LoginApiResponse, UserDetailsApiResponse } from '../../types/user/types'
import { api } from '../api'

export const login = async ({ usuario, senha }: LoginApiRequest): Promise<LoginApiResponse> => {
  const url = `/usuarios/loginextranet`

  const { data } = await api.post<LoginApiResponse>(url, {
    Usuario: usuario,
    Senha: senha,
  })

  return data
}

export const fetchUserDetails = async (): Promise<UserDetailsApiResponse> => {
  const url = `/usuarios/extranet/dadosusuariologado`

  const { data } = await api.get<UserDetailsApiResponse>(url)

  return data
}
